import { Injectable } from '@angular/core';
import { compile as handlebarsCompile } from "handlebars";

@Injectable({
	providedIn: 'root'
})
export class AdaptiveCardsService {
	loadFeedTemplate(data: any) {
		return this.compileHandlebars(JSON.parse(atob(data.template.templateJson)), data);
	}

	compileHandlebars(template: any, data: any): any {
		try {
			const handlebarTemplate = handlebarsCompile(JSON.stringify(template));
			const initialDataMapping = handlebarTemplate(data);
			const FinalTemplate = handlebarsCompile(initialDataMapping);

			// Mapping compiled handlebars with the template json and returning
			return FinalTemplate(data);
		} catch (e) { }
	}

}
